const ACTION_TYPE_EDIT_EXTERNAL_INTEGRATION_REQUEST = 'ACTION_TYPE_EDIT_EXTERNAL_INTEGRATION_REQUEST';
const ACTION_TYPE_EDIT_EXTERNAL_INTEGRATION_SUCCESS = 'ACTION_TYPE_EDIT_EXTERNAL_INTEGRATION_SUCCESS';
const ACTION_TYPE_EDIT_EXTERNAL_INTEGRATION_FAILURE = 'ACTION_TYPE_EDIT_EXTERNAL_INTEGRATION_FAILURE';

export {
  ACTION_TYPE_EDIT_EXTERNAL_INTEGRATION_REQUEST,
  ACTION_TYPE_EDIT_EXTERNAL_INTEGRATION_SUCCESS,
  ACTION_TYPE_EDIT_EXTERNAL_INTEGRATION_FAILURE,
};
